// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"W2fUj","hidden":"_1AlWx","container":"_1M4Tt","fillAllSpace":"_2-pf-","fullScreen":"_1_4y7"};